import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { Dispatch } from 'redux'
import { InfoOutlined, CropOriginal } from '@material-ui/icons'
import { IGroupDetailed } from '../../types/group'
import { Modals } from '../../types/modal'
import { IGroupParam } from '../../types/router'
import { getGroupById, clearGroupData, deleteGroup } from '../../actions/group'
import { modalClose, modalOpen } from '../../actions/modal'
import { PrimaryThemeProvider } from '../../styles'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import {
  UpdateGroupForm,
  UpdateGroupPublishingCapabilitiesForm,
} from '../../forms'
import {
  CombinedTitle,
  TabsHead,
  View,
  SettingsMenu,
  Modal,
  P,
  SettingDeleteArea,
} from '../../components'

export interface IGroupSettingsPageConnectedProps {
  group?: IGroupDetailed
  activeModal?: Modals
  editable: boolean
  dispatch: Dispatch
}

export const GroupSettingsPage = ({
  match: {
    params: { groupId },
  },
  group,
  activeModal,
  editable,
  dispatch,
}: IGroupSettingsPageConnectedProps & RouteComponentProps<IGroupParam>) => {
  useEffect(() => {
    dispatch(getGroupById(groupId))
    return () => {
      dispatch(clearGroupData())
    }
  }, [groupId, dispatch])
  return group ? (
    <Main
      sidebarSecondary={<SettingsMenu />}
      titleBlock={
        <>
          <CombinedTitle first={group.shortTitle} second="Group Settings" />
          <TabsHead
            tabs={[
              {
                label: 'Details',
                value: 'details',
                icon: <InfoOutlined />,
              },
              {
                label: 'Capabilities',
                value: 'capabilities',
                icon: <CropOriginal />,
              },
            ]}
          />
        </>
      }
      helmet={`Administration: Publishing Groups: ${group.shortTitle}`}
    >
      <View keep tab="details">
        <Scrollable>
          <SettingFormsWrapper>
            <UpdateGroupForm />
            <SettingDeleteArea
              onClickHandler={() =>
                dispatch(modalOpen(Modals.deleteConfirmModal))
              }
              texts={{
                title: 'Delete group',
                description:
                  'In order to delete this group you need to delete all media within the group—go to the group publishing area, and delete all graphics first. Also please note that this action is not reversible and cannot be undone.',
                buttonLabel: 'Delete this Group',
              }}
              buttonProps={{ id: 'delete-group-dialog' }}
              disabled={!editable}
            />
          </SettingFormsWrapper>
          <Modal
            open={activeModal === Modals.deleteConfirmModal}
            handleClose={() => {
              dispatch(modalClose())
            }}
            action={() => {
              dispatch(deleteGroup(groupId))
              dispatch(modalClose())
            }}
            title="Group deletion"
            actionLabel="Delete"
          >
            <P>
              This publishing group will be deleted—please note that this action
              is not reversible and cannot be undone.
            </P>
            <br />
            <P>
              Are you sure you want to delete <strong>{group.name}</strong>{' '}
              publishing group?
            </P>
          </Modal>
          <PrimaryThemeProvider>
            <Modal
              id="delete-pack-modal-dialog"
              type="info"
              open={activeModal === Modals.deleteStatusModal}
              handleClose={() => {
                dispatch(modalClose())
              }}
              title="This publishing group can’t be deleted"
            >
              <P>{group.message}</P>
            </Modal>
          </PrimaryThemeProvider>
        </Scrollable>
      </View>
      <View keep tab="capabilities">
        <UpdateGroupPublishingCapabilitiesForm group={group} />
      </View>
    </Main>
  ) : null
}
